import Type from 'types/type'
import { Column } from 'types/column' // eslint-disable-line
import { tObj } from 'helpers/methods/translate'
import store from 'redux/store'
import parseJson from 'helpers/methods/parseJson'
import time, { getLocaleFromLang } from 'helpers/methods/time'

const renderDateByCurrentLang = date => {
    const lang = store.getState().common?.lang
    const locale = getLocaleFromLang(lang)

    return date
        ? time(date, { locale }).getCleanDate({
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        })
        : '-'
}

/**
 * List of Columns
 * @type {Column[]}
 * @readonly
 */
const userBaseColumns = [
    {
        fieldName: 'email',
        name: 'email',
        type: Type.STRING,
    },
    {
        fieldName: 'lastname',
        name: 'lastname',
        type: Type.STRING,
    },
    {
        fieldName: 'firstname',
        name: 'firstname',
        type: Type.STRING,
    },
    {
        fieldName: 'phoneNumber',
        name: 'phoneNumber',
        type: Type.STRING,
    },

    {
        fieldName: 'profile.name',
        name: 'profile',
        type: Type.STRING,
        onRender: item => tObj.call({ props: { lang: store.getState().common?.lang } }, parseJson(item['profile.name'])),
    },
]

/**
 * List of Columns
 * @type {Column[]}
 * @readonly
 */
const userColumns = [
    {
        fieldName: 'registrationNumber',
        name: 'registrationNumber',
        type: Type.STRING,
    },
    ...userBaseColumns,
]

/**
 * List of Columns
 * @type {Column[]}
 * @readonly
 */
export const clientAccountColumns = [
    {
        fieldName: 'client.name',
        name: 'client',
        type: Type.STRING,
    },
    ...userBaseColumns,
    {
        fieldName: 'lastConnectionDate',
        name: 'lastConnectionDate',
        type: Type.DATE,
        onRender: item => renderDateByCurrentLang(item.lastConnectionDate),
    },
    {
        fieldName: 'enabledDisabled',
        name: 'enabledDisabled',
        type: Type.BOOLEAN,
        onRender(item) {
            return this.renderEnabledDisabledToggle(item)
        },
    },
]

export default userColumns
